/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Ptz_HintInputs */

const vi_grower_area_camera_ptz_hint = /** @type {(inputs: Grower_Area_Camera_Ptz_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bấm giữ để quay, thả ra là dừng. API chưa có zoom và điểm đặt trước.`)
};

/**

* @param {Grower_Area_Camera_Ptz_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_ptz_hint = /** @type {((inputs?: Grower_Area_Camera_Ptz_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Ptz_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_ptz_hint(inputs)
});